import moment from "moment";

export const Dummy = () => {
  return {
    data: {
      booking: {
        email: "dev.admin@okkami.com",
        fulfillment_type_name: "pre_checkin",
        node_id: "37770",
        status: "ready_to_pre_checkin", // the status includes ready_to_pre_checkin, booking_in_the_past, pre_check_in_completed and room_is_ready
        store_kind: "pre_checkin",
        resv_id: "237401",
        booking_id: "1234567",
        arrival_date: moment().toISOString(),
        departure_date: moment().add(1, "day").toISOString(),
        flight_no: "FD-0708",
        flight_arrive_time: moment().toISOString(),
        dob: "06/08/1994",
        nationality: "Thai",
        arrival_card: "1234",
        room_description: "Standard Room",
        number_of_guests: "2",
        total: "Demo Mode",
        room_rate: "3500",
        advance_deposit: "0",
        phone: {
          phone_id: null,
          phone_role: null,
          phone_type: null,
          phone_number: "35512341234",
          phone_country_code: "66",
          phone_number_without_code: "812345678",
        },
        title: "Mr",
        gender: "UNKNOWN",
        guests: [
          {
            adults: 2,
          },
          {
            child: 0,
          },
          {
            infant: 0,
          },
        ],
        address: {
          city_name: null,
          address_id: "226114",
          address_type: "HOME",
          country_of_residence: "Thailand",
          country_of_residence_code: "TH",
        },
        bed_kind: ["TWN", "KNG"],
        check_in: moment().toISOString(),
        email_id: "302123",
        passport: {
          primary: null,
          document_id: null,
          effective_date: null,
          place_of_issue: null,
          document_number: null,
          country_of_issue: null,
        },
        check_out: moment().add(2, "day").toISOString(),
        last_name: "Admin",
        room_code: "AK",
        first_name: "Dev",
        profile_id: "218710",
        total_guests: 2,
        number_of_rooms: 1,
        nationality_code: "TH",
        special_requests: [],
        currency: "USD",
        pre_auth_amount: {
          total_pre_auth_in_text: "100.00",
          total_pre_auth: "10000",
        },
        preferences: [
          {
            preference_type: "SPECIALS",
            description: "Art and Design",
            preference_value: "AS",
            selected: true,
          },
          {
            preference_type: "SPECIALS",
            description: "Adrenaline Activities",
            preference_value: "AV",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Culture and Exploration",
            preference_value: "CC",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Dietary",
            preference_value: "DY",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Fitness",
            preference_value: "FF",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Families and Kids",
            preference_value: "FK",
            selected: true,
          },
          {
            preference_type: "SPECIALS",
            description: "Food, Wine and Tipples",
            preference_value: "FW",
            selected: true,
          },
          {
            preference_type: "SPECIALS",
            description: "Volunteering and Community Activism",
            preference_value: "GJ",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Wellness and Wellbeing",
            preference_value: "HH",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Marine Discovery",
            preference_value: "MM",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Sports",
            preference_value: "S6",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Sustainability and Upcycling",
            preference_value: "SN",
            selected: false,
          },
          {
            preference_type: "SPECIALS",
            description: "Sailing and Cruising",
            preference_value: "SY",
            selected: true,
          },
        ],
      },
      status: "ok", // the status includes finish, ok and not_acceptable
    },
  };
};
